import React from 'react';
import {Alert,Container,CssBaseline,ThemeProvider} from '@mui/material';
import theme from '../../theme/theme';
import OverviewTab from './overview/OverviewTab';
import {counted} from '../../lib/socialsCounts';
import {publishSlotService,parseSlots,parseReady,parseCaption,parseSlot} from '../../services/publishSlotService';
import original from '../../services/__fixtures__/stage3/caption.json';
import saved from '../../services/__fixtures__/stage3/caption-saved.json';
import ready from '../../services/__fixtures__/stage3/ready.json';
import created from '../../services/__fixtures__/stage3/created.json';
import moved from '../../services/__fixtures__/stage3/moved.json';
import cancelled from '../../services/__fixtures__/stage3/cancelled.json';
import scheduled from '../../services/__fixtures__/stage3/scheduled.json';
import missed from '../../services/__fixtures__/stage3/missed.json';
import {runtimeEnvironment} from '../../lib/runtimeEnvironment';

/** Local visual replay of committed staging responses, never a live API client.
 * Operations return the captured response; this proves UI rendering/click wiring,
 * not hosted authentication or arbitrary edits. Production cannot enter here.
 */
let installed=false;
function installReplay(){
 if(installed)return;
 if(runtimeEnvironment.environment==='production')throw new Error('Local replay only');
 installed=true;
 let state=new URLSearchParams(window.location.search).get('stage3')??'unscheduled';
 publishSlotService.list=async()=>parseSlots(state==='missed'?missed:state==='scheduled'?scheduled:state==='moved'?{items:[moved]}:{items:[]});
 publishSlotService.approvedUnscheduled=async()=>parseReady(state==='scheduled'||state==='moved'?{...ready,items:[]}:ready);
 publishSlotService.caption=async()=>parseCaption(original);
 publishSlotService.saveCaption=async()=>parseCaption(saved);
 publishSlotService.create=async()=>{state='scheduled';return parseSlot(created);};
 publishSlotService.move=async()=>{state='moved';return parseSlot(moved);};
 publishSlotService.cancel=async()=>{state='unscheduled';return parseSlot(cancelled);};
}
export default function Stage3Harness(){
 installReplay();
 return <ThemeProvider theme={theme}><CssBaseline/><Container maxWidth="xl" sx={{py:2}}>
  <Alert severity="info" sx={{mb:2}}>LOCAL STAGING RESPONSE REPLAY — no live writes or publishing. Captured on September 20; click responses replay the recorded dates.</Alert>
  <OverviewTab connected counts={{toReview:counted(0),approvedWaiting:counted(1),conversations:counted(0)}}
   scheduled={[]} posted={[]} readyToSchedule={[{reviewId:created.review_id,subject:'Midtown apartment tour',template:'property_tour',about:null}]}
   unmatched={counted(0)} weeklyGoal={5} now={new Date('2026-09-20T18:00:00Z')}/>
 </Container></ThemeProvider>;
}
